import { ladlesRepository } from "@/repositories/roots/ladlesRepository";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Location } from "../models/ladle-plant-overview.dto";
import { RootDetails } from "../models/root-detail.dto";

interface LocationSelectedState {
	isRootLoading?: boolean;
	root?: RootDetails;
	location?: Location;
}

const initialState: LocationSelectedState = {
	isRootLoading: false,
};

export const getRootDetails = createAsyncThunk(
	"@plantOverview/locationSelected/getRootDetails",
	async (rootId: number) => {
		const resp = await ladlesRepository.getRootDetails(rootId);
		return resp.data;
	},
);

export const locationSelectedReducer = createSlice({
	name: "@plantOverview/locationSelected",
	initialState,
	reducers: {
		setLocation: (state, action) => {
			state.location = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getRootDetails.fulfilled, (state, action) => {
				state.root = action.payload;
				state.isRootLoading = false;
			})
			.addCase(getRootDetails.pending, (state, action) => {
				state.isRootLoading = true;
				state.root = undefined;
			});
	},
});

export const { setLocation } = locationSelectedReducer.actions;
